import BaseTasksSelector from '../../user/userlist/task/BaseTaskSelector'
import TaskListController from '../../user/add_tasks/TaskListController'
import makeRpcCall from "../../util/jquery_rpc"
import messageResource from "../../messageResource"

export default class ImportTasksSelector extends BaseTasksSelector {
    constructor($containerEl, params) {
        super($containerEl, params);

        this.state = {
            ...this.state,
            importOnlyActiveProjects: true,
            importDescriptions: false
        }

        this.onStatePropertyChanged("importOnlyActiveProjects", importOnlyActiveProjects => {
            this.$importArchivedCheckbox.attr("checked", !importOnlyActiveProjects);
            this.taskListController.setInActiveProjects(importOnlyActiveProjects);
            this.showCpSelectorController(true);
        })
        this.onStatePropertyChanged("importDescriptions", importDescriptions => {
            this.$importDescriptionsCheckbox.attr("checked", importDescriptions);
        })
    }

    createTaskListController(params) {
        return new TaskListController(params)
    }

    afterRender() {
        super.afterRender();

        this.$importArchivedCheckbox = this.find(".importArchivedCheckbox").click(() => this.setState({
            importOnlyActiveProjects: !this.state.importOnlyActiveProjects
        }));
        this.$importDescriptionsCheckbox = this.find(".importDescriptionsCheckbox").click(() => this.setState({
            importDescriptions: !this.state.importDescriptions
        }));

        this.$panel.addClass("importTasksSelector");
    }

    selectCpSectionAdditionalControlsTemplateHtml() {
        return "<label>" +
               "  <input type='checkbox' class='importArchivedCheckbox'>" +
               "  <span class='label'><%-importArchived%></span>" +
               "</label>"
    }

    bottomPanelTemplateHtml() {
        return "<div class='bottomPanel'>" +
               "  <label>" +
               "    <input type='checkbox' class='importDescriptionsCheckbox'>" +
               "    <span class='label'><%-importTaskDescriptions%></span>" +
               "  </label>" +
               "  <div class='greyButton withIcon importSelectedButton disabled'>" +
               "    <span class='buttonIcon'>" +
               "      <span class='buttonImportTitle'><%-importSelected%></span>" +
               "    </span>" +
               "  </div>" +
               "</div>"
    }

    getApplyButtonClass() {
        return "importSelectedButton"
    }

    messageKeys() {
        return {
            ...super.messageKeys(),
            importArchived: "task_selector.import_archived",
            importTaskDescriptions: "task_selector.import_descriptions",
            importSelected: "task_selector.import_selected"
        }
    }

    _getSelection() {
        return {
            ...super._getSelection(),
            importOnlyActiveProjects: this.state.importOnlyActiveProjects,
            importDescriptions: this.state.importDescriptions
        }
    }

    _getCPListRpcCall(onSuccess, onError) {
        return makeRpcCall("RetrieveCustomersProjectsService.getCPListForImportTasksSelector", [this.state.importOnlyActiveProjects], onSuccess, onError);
    }

    _selectAllForCustomerMessage() {
        return this.state.importOnlyActiveProjects ?
               messageResource.getMessage("import_tasks_selector.select_all_for_customer.only_active_projects") :
               messageResource.getMessage("import_tasks_selector.select_all_for_customer")
    }

    _selectAllForProjectMessage() {
        return messageResource.getMessage("import_tasks_selector.select_all_for_project")
    }

    onCustomersProjectsRequestComplete(data) {
        this.cpSelectorController.init(data, this.state.importOnlyActiveProjects);
        this.cpSelectorController.stopSpin();
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/ImportTasksSelector.js